import { useEffect, useState, useCallback } from "react";
import { BezierWrapper } from "../components/BezierWrapper";
import { ElasticWrapper } from "../components/ElasticWrapper";
import { BounceWrapper } from "../components/BounceWrapper";
import { PresetsWrapper } from "../components/PresetsWrapper";
import { ConfigWrapper } from "../components/ConfigWrapper";
import { useGlobalState } from "../hooks/useGlobalState";
import { os, path, fs } from "../lib/node";
import { StyledMainContainer } from "../styles/StyledMainContainer";
import { Leva } from "leva";
import { CustomTheme } from "../styles/CustomTheme";
import { version, name } from "../../../package.json";
import { useNotifications } from "../context/NotificationProvider";
import {
	csi,
	evalES,
	evalFile,
	openLinkInBrowser,
	subscribeBackgroundColor,
	subscribeDebugger,
	vulcanListen,
	vulcanSend,
} from "../lib/utils";
import { LicenseWrapper } from "@pluginplay/pp-cep-license";

const Main = () => {
	const [bgColor, setBgColor] = useState("#282c34");
	const isMac = csi.getOSInformation().indexOf("Mac") !== -1;

	useEffect(() => {
		if (window.cep) {
			csi.addEventListener("cep.debug", function (event: any) {
				alert("Debug message from CEP: " + event.data);
			});
		}
	}, []);
	//@ts-ignore

	useEffect(() => {
		if (window.cep) {
			subscribeBackgroundColor(setBgColor);
			subscribeDebugger();
			const extRoot = csi.getSystemPath("extension");
			const jsxSrc = `${extRoot}/jsx/index.js`;
			const jsxBinSrc = `${extRoot}/jsx/index.jsxbin`;
			if (fs.existsSync(jsxSrc)) {
				console.log(jsxSrc);
				evalFile(jsxSrc);
			} else if (fs.existsSync(jsxBinSrc)) {
				console.log(jsxBinSrc);
				evalFile(jsxBinSrc);
			}

			let keyEventsToRegister;
			if (isMac) {
				keyEventsToRegister = JSON.stringify([
					{ keyCode: 55 }, // Key code for Meta
					{ keyCode: 56 }, // Key code for Shift
					{ keyCode: 56, metaKey: true }, // Key code for Shift + Meta
				]);
			} else {
				keyEventsToRegister = JSON.stringify([
					{ keyCode: 10 }, // Key code for Shift
					{ keyCode: 11 }, // Key code for Control
					{ keyCode: 11, ctrlKey: true }, // Key code for Control + ctrl
				]);
			}
			csi.registerKeyEventsInterest(keyEventsToRegister);
		}
	}, []);

	const { UIStatus, dispatch, keysHeld } = useGlobalState();
	const { addNotification } = useNotifications();

	const upHandler = useCallback(
		(e: KeyboardEvent): void => {
			// console.log(e.key)
			if (e.key === "Shift") {
				dispatch({ type: "keysHeld", payload: { ...keysHeld, shift: false } });
			}
			if (isMac ? e.key === "Meta" : e.key === "Control") {
				dispatch({ type: "keysHeld", payload: { ...keysHeld, ctrl: false } });
			}
		},
		[dispatch, keysHeld, isMac]
	);

	const downHandler = useCallback(
		(e: KeyboardEvent): void => {
			// console.log(e.key)
			if (e.key === "Shift") {
				dispatch({ type: "keysHeld", payload: { ...keysHeld, shift: true } });
			}
			if (isMac ? e.key === "Meta" : e.key === "Control") {
				dispatch({ type: "keysHeld", payload: { ...keysHeld, ctrl: true } });
			}
		},
		[dispatch, keysHeld, isMac]
	);

	useEffect(() => {
		document.addEventListener("keydown", downHandler, true);
		document.addEventListener("keyup", upHandler, true);
		return () => {
			document.removeEventListener("keydown", downHandler);
			document.removeEventListener("keyup", upHandler);
		};
	}, []);

	return (
		// <LicenseWrapper
		// 	csi={csi}
		// 	evalES={evalES}
		// 	vulcanListen={vulcanListen}
		// 	vulcanSend={vulcanSend}
		// 	version={version}
		// 	toolName={name}
		// 	freeMode={false}
		// 	addNotification={addNotification}
		// >
		<StyledMainContainer tabIndex={0}>
			<Leva
				theme={CustomTheme}
				fill={true} // default = false,  true makes the pane fill the parent dom node it's rendered in
				flat={true} // default = false,  true removes border radius and shadow
				oneLineLabels // default = false, alternative layout for labels, with labels and fields on separate rows
				titleBar={false} // default = false, hides the GUI header
				collapsed={false} // default = false, when true the GUI is collpased
				hidden={false} // default = false, when true the GUI is hidden
			/>
			{UIStatus.currentDisplay === "bezier" ? <BezierWrapper /> : null}
			{UIStatus.currentDisplay === "distribute" ? <BezierWrapper /> : null}
			{UIStatus.currentDisplay === "bounce" ? <BounceWrapper /> : null}
			{UIStatus.currentDisplay === "elastic" ? <ElasticWrapper /> : null}
			{UIStatus.currentDisplay === "config" ? <ConfigWrapper /> : null}
			{UIStatus.currentDisplay === "presets" ? <PresetsWrapper /> : null}
		</StyledMainContainer>
		// </LicenseWrapper>
	);
};

export default Main;
